import React from 'react'



const src =
  "https://youtu.be/D2Q2albPgFM?si=G7YwUEgJZlwssrtA";

const Story = () => {
  return (
    <div>
 
  <br />
  <div className="text-center">
            <h2 className="text-3xl font-bold leading-tight text-gray-900 sm:text-4xl xl:text-5xl font-pj">हम कौन हैं- मिलें हमारे चिकित्सक</h2>
        </div>

    <div class="max-w-6xl px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
    <div  class="min-h-[35vh] bg-photo  bg-center bg-cover bg-no-repeat relative rounded-xl md:min-h-[75vh]">
      
    <div class="absolute bottom-0 start-0 end-0 max-w-xs text-center mx-auto p-6 md:start-auto md:text-start md:mx-0">
      
      <div class="px-5 py-4 inline-block bg-white rounded-lg md:p-7 ">
        <div class="hidden md:block">
          <h3 class="text-lg font-bold text-gray-800 sm:text-2xl ">Pawan Bhandari</h3>
          <h4><h3>MSC in Drug chemistry</h3></h4>
          <p class="mt-2 ">आपके स्वास्थ्य का सफर , हमारी देखभाल - संपूर्ण स्वास्थ्य, संपूर्ण ख़ुशी</p>
        </div>

        <div class="md:mt-10">
          <a class="flex items-center gap-2 text-sm font-medium text-gray-800 hover:text-gray-500  dark:hover:text-gray-400" href="https://youtu.be/D2Q2albPgFM?si=GMufYIMgSkZsEIU0">
            <svg class="flex-shrink-0 w-4 h-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="5 3 19 12 5 21 5 3"/></svg>
            Watch our story
            

          </a>
        </div>
      </div>
     
    </div>
  </div>
</div>



    </div>
  )
}

export default Story
